import React, {useEffect, useState} from 'react';
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Radio,
    RadioGroup,
    Typography
} from '@deere/fuel-react';
import {Controller} from "react-hook-form";
import {FeedbackComments} from "./FeedbackComments";
import {FeedbackViewComments} from "./FeedbackViewComments";
import {NOT_APPLICABLE} from "../shared/Constants";

export const FeedbackYesNo = ({
                                  criteria,
                                  state,
                                  control,
                                  options,
                                  onChange,
                                  criteriaId,
                                  statusValue,
                                  commentValue,
                                  naValue,
                                  errors
                              }) => {
    const [disabled, setDisabled] = useState(false)
    const [radioValue, setRadioValue] = useState(statusValue)
    const [isRadioRequired, setIsRadioRequired] = useState(true)

    const handleNotApplicable = (event) => {
        if (event.target.checked === true) {
            setDisabled(true)
            setRadioValue("")
            setIsRadioRequired(false)
        } else {
            setDisabled(false)
            setIsRadioRequired(true)
        }
        onChange(event.target.checked)
    }

    const validateErrors = keyValue => {
        return Object.keys(errors).length !== 0 && Object.keys(errors).includes(keyValue)
    }

    const handleTypeChange = (event) => {
        if (event.target.checked === true) {
            setRadioValue(event.target.value)
            onChange(event.target.checked)
        }
    }

    useEffect(() => {
        if (naValue) {
            setDisabled(true)
            setIsRadioRequired(false)
        }

        return () => {
            setDisabled(false);
            setIsRadioRequired(true)
        }
    }, [naValue]);

    return (
        <Grid container direction="row"
              justifyContent="flex-start"
              alignItems="flex-start">
            <Grid item xs={12} md={10}>
                <Typography display='inline' variant="label">
                    {criteria}{" "}
                </Typography>
                {state.responseStatus.id === 1 && (
                    <span
                        aria-label="required field"
                        className="uxf-is-required"
                    > * </span>
                )}
            </Grid>
            <Grid item xs={12} md={2}>
                <Box display="flex" justifyContent="flex-end">
                    {state.responseStatus.id === 1 && (
                        <FormControl component="fieldset">
                            <Controller
                                control={control}
                                defaultValue={naValue}
                                name={`${criteriaId}n/a`}
                                render={({onChange, value}) => (
                                    <FormControlLabel
                                        style={{marginRight: 0}}
                                        control={<Checkbox name={`${criteriaId}n/a`}
                                                           defaultChecked={naValue}/>}
                                        label={NOT_APPLICABLE}
                                        onChange={(e) => {
                                            onChange(e.target.checked);
                                            handleNotApplicable(e)
                                        }}
                                    />
                                )}
                            />
                        </FormControl>
                    )}
                </Box>
            </Grid>
            {state.responseStatus.id === 2 ? (
                <Grid item xs={12}>
                    {naValue ? (
                        <>
                            <Typography variant="label" display="inline">
                                {NOT_APPLICABLE};
                            </Typography>
                            &nbsp; <FeedbackViewComments comments={commentValue}/>
                        </>
                    ) : (
                        <>
                            <Typography variant="label" display="inline">
                                {radioValue === 'Y' ? "Yes;" : radioValue === 'N' ? "No;" : ""}
                            </Typography>
                            &nbsp; <FeedbackViewComments comments={commentValue}/>
                        </>
                    )}
                </Grid>
            ) : (
                <>
                    <Grid item xs={12} md={2}>
                        <FormControl disabled={disabled} error={validateErrors(`${criteriaId}feedbackStatus`)}
                                     required={!disabled} fullWidth p={2} component="fieldset">
                            <Controller
                                rules={{required: isRadioRequired}}
                                control={control}
                                defaultValue={radioValue}
                                name={`${criteriaId}feedbackStatus`}
                                render={({onChange, value}) => (
                                    <RadioGroup
                                        aria-label={`${criteriaId}feedbackStatus`}
                                        name={`${criteriaId}feedbackStatus`}
                                        value={radioValue}
                                        onChange={(e) => {
                                            onChange(e);
                                            handleTypeChange(e);
                                        }}
                                        row>
                                        {options && options.map((item) => {
                                            return (
                                                <FormControlLabel key={item.value} value={item.value} control={<Radio/>}
                                                                  label={item.label}/>
                                            );
                                        })}
                                    </RadioGroup>
                                )}
                            />
                            <FormHelperText>{isRadioRequired && validateErrors(`${criteriaId}feedbackStatus`) && "Please select a value"}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={10}>
                        <FeedbackComments
                            control={control}
                            showLabel={false}
                            state={state}
                            disabled={disabled}
                            name={`${criteriaId}qualityComments`}
                            generalComments={commentValue}
                            rowsHeight={3}
                            placeholder={"Feedback Comments (Optional)"}
                        />
                    </Grid>
                </>
            )
            }
        </Grid>
    )
}
